@if (show) {
    @if (blocking) {
        <!-- Held on purpose: a report being generated, where carrying on would
             only produce a second one. -->
        <div class="overlay">
            <div class="loading-container">
                <mat-progress-spinner [diameter]="40" [strokeWidth]="4" [mode]="mode" color="primary"></mat-progress-spinner>
                <div class="loading-text">Loading<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></div>
            </div>
        </div>
    } @else {
        <!-- Ordinary traffic. A line across the top says the same thing as a
             full-screen curtain and does not swallow the next three clicks,
             which is what made the menu feel broken. -->
        <mat-progress-bar class="loading-line" [mode]="mode" [value]="progress" color="primary"></mat-progress-bar>
    }
}
